import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import discover125 from "../../images/discover-125.jpg";
import "../../../src/product.css";

const Discover125 = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">DISCOVER 125cc</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={discover125}
              alt="Bajaj Discover 125cc"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Turn on the ignition of a Bajaj Discover 125. Remember, you are
              going to get two things: unexpected power and no compromises on
              mileage. Take a closer look at Discover 125. Notice its design.
              The style it embodies. Go a little deeper – witness Bajaj’s
              patented technologies at work. Now, grab the handles and hop on.
              An exciting ride is about to begin.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>124.5 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>Manual</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Petrol</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>121 kg</strong>
            </div>

            <div className="spec-card">
              <span>Max Speed</span>
              <strong>100 Kmph</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default Discover125;